import React from 'react'

class DataLoader extends React.Component {


  constructor(){
    super()


    let serverURL;

    //console.log(window.location.hostname ==='localhost');


    (window.location.hostname ==='localhost')?
      serverURL = 'https://malaguti.bike/'
    : serverURL = '/'


    //serverURL = 'https://malaguti-bicycles.com/'

    //serverURL = 'https://brixton-motorcycles.com/wp/'
    //serverURL = '//brixton.stageserver.co.uk/wp/'
    //serverURL = '//wp.brixton-motorcycles.com/'
    //serverURL = 'http://s2kk5s7m8.gb-02.live-paas.net/wp/'
    // live


    this.state = {
        serverURL,
        loaded:false,
        pageNumber:1,
        dealerPage:1,
        allDealersLoaded:false,
        dealers:[]
    }


    this.dealersDataLoaded = this.dealersDataLoaded.bind(this)

    this.setDealersData = this.setDealersData.bind(this)

  }



  loadDealers(){
    //console.log("Load More Dealers",this.state.dealerPage);
    let url = this.state.serverURL +'wp-json/wp/v2/dealer/?per_page=100&page='+this.state.dealerPage

    //let url = this.state.serverURL +'restcopy/dealer'+this.state.dealerPage+'.json'
      fetch(url)
        .then(results => results.json())
        .then(array => {
            this.dealersDataLoaded(array)

        })
  }
  dealersDataLoaded(array){


    

      // only add dealers if there are some

      if(array.length){

        this.setDealersData(array)
        this.setState({loaded:true})
      }else if(array.code === 'rest_post_invalid_page_number'){
        console.log('rest_post_invalid_page_number')
        this.setState({loaded:true})
      }else{ 
        console.log("We have an even 100 of dealers")
      }

        if(array.length===100){
          console.log("Load More Dealers");
          this.setState({dealerPage:(this.state.dealerPage+1)})

          this.loadDealers()

        }else{

         this.props.setData(this.state.dealers)
          this.setState({allDealersLoaded:true,loaded:true})


        }

    
  }


  setDealersData(data){

    //console.log(data[0]);

    let dealers = this.state.dealers.concat(data);

        //console.log(dealers);

        console.log("dealers loaded",dealers.length);
        this.setState({dealers})
  }




  componentWillMount(){



          this.loadDealers()
          //setTimeout(()=>this.loadDealers(),1);




      //  console.log(window.location);


  }

  componentWillUpdate(){
      //console.log("DataLoader",this);
  }


  render () {





    return(
      <div>

      { this.state.loaded?
          this.props.children
        :
        <div className="loading">


        </div>
      }

      </div>
    )
  }
};



export default DataLoader
